import React from 'react'
import { Button, Form, Input, message, Modal } from 'antd'
import validator from '../../../validator'
import { inject, observer } from 'mobx-react'
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import createMyFolderStore from './createMyFolderStore'

const CreateMyFolderModal = props => {
  const { visible, parentFolderId, onClose } = props
  const [form] = Form.useForm()

  const onFinish = values => {
    const { folder_name } = values

    let fileParam = {
      name: folder_name,
      parentId: parentFolderId,
      type: 'folder',
    }
    createMyFolderStore
      .create(fileParam)
      .then(() => {
        createMyFolderStore.isLoading = false
        closeAndResetForm()
      })
      .catch(e => {
        createMyFolderStore.isLoading = false
        if (e && e.errorCode && e.errorCode == 'PERMISSION-100') {
          message.error('Không có quyền tạo thư mục ở đây')
        } else {
          message.error('Đã có lỗi xảy ra!')
        }
      })
  }

  const closeAndResetForm = () => {
    form.resetFields()
    onClose()
  }

  return (
    <>
      <Modal
        footer={null}
        closable={true}
        visible={visible}
        onCancel={() => {
          closeAndResetForm()
        }}
        title="Tạo thư mục">
        <Form form={form} layout={'vertical'} onFinish={onFinish}>
          <Form.Item
            name={'folder_name'}
            rules={[
              { required: true, message: 'Vui lòng nhập tên thư mục!' },
              { validator: validator.validateInputString },
            ]}
            label={'Tên thư mục:'}>
            <Input placeholder={'Nhập tên thư mục'} />
          </Form.Item>

          <Form.Item>
            <Button
              icon={<PlusOutlined />}
              loading={createMyFolderStore.isLoading}
              htmlType={'submit'}
              type={'primary'}>
              Tạo
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default inject(
  'fileStore',
  'resourcesStore'
)(observer(CreateMyFolderModal))
